module.exports = __webpack_public_path__ + "static/stickers.c97341e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stickers.jpg
// module id = 1707
// module chunks = 173894859265406